<template>
	<v-dialog scrollable persistent v-model="showDialog" max-width="820">
		<v-card>
			<v-card-title>Report Filters</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-text-field
							disabled
							v-if="hasCustomData"
							label="Schema"
							v-model="report.CustomData"
							:rules="[rules.required]"
						/>
						<v-select
							v-else
							label="Schema"
							v-model="schema"
							:items="schemas"
							item-value="Id"
							item-text="Name"
						/>
					</v-row>
					<filter-component
						v-if="filter && showFilterComponent"
						:columns="fields"
						:filter="filter"
						:index="-1"
						@filterChanged="filterChanged"
					/>
					<!-- <v-row no-gutters>
                        <v-autocomplete label="Field" :items="fields" item-value="Id" v-model="field" item-text="Label" :rules="[rules.required]" />
                    </v-row>
                    <v-row no-gutters>
                        <v-select label="Operator" v-model="operator" :items="operators" item-text="label" item-value="value" :rules="[rules.required]" />
                    </v-row>
                    <v-row no-gutters >
                        <v-text-field label="Value" v-model="value" :rules="[rules.required]" />
                    </v-row> -->
				</v-form>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn color="primary" @click.stop="onSave">
					<v-icon class="mr-2">mdi-content-save</v-icon>Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { ReportDetailsGetters } from '../../../../../store/getters';
import { ReportDetailsActions } from '../../../../../store/actions';
import { reportTypes } from '../../../../../enums/reportTypes';
import { advancedFilterOperators } from '../../../../../enums/dropdownHelpers/advancedFilterOperators';
import FilterComponent from '../../../../shared/gridViews/FilterComponent.vue';
export default {
	name: 'ReportFilterModal',
	props: {
		showDialog: Boolean,
		reportFilter: Object,
	},
	components: { FilterComponent },
	computed: {
		hasCustomData() {
			if (!this.report) return null;
			if (!this.report.Type) return false;
			return this.report.Type == reportTypes.CUSTOM_DATA;
		},
		...mapGetters({
			report: [ReportDetailsGetters.REPORT],
			reportGridViewFields: [ReportDetailsGetters.REPORT_GRIDVIEW_FIELDS],
			reportFields: [ReportDetailsGetters.REPORT_FIELDS],
			schemas: [ReportDetailsGetters.REPORT_FIELDS_SCHEMAS],
		}),

		fields() {
			if (!this.reportFields) return [];
			if (this.hasCustomData) return this.reportFields;
			if (!this.schema) return this.reportFields;
			let result = [];
			this.reportFields.forEach((field) => {
				let gvf = this.reportGridViewFields.find(
					(x) => x.Id == field.GridViewFieldId
				);
				if (gvf && gvf.EntityId == this.schema) {
					result.push(field);
				}
			});
			return result;
		},
		showFilterComponent() {
			if (this.show == false) return true;
			if (this.reportFilter && this.show == true) return true;
			return null;
		},
	},
	watch: {
		schema(newVal, oldVal) {
			if (oldVal && newVal) {
				this.filter.FieldId = null;
			}
		},
	},
	data() {
		return {
			rules: {
				required: (value) => !!value || 'Field is required',
			},
			operators: advancedFilterOperators,
			schema: null,
			show: false,
			filter: null,
		};
	},
	mounted() {
		if (this.reportFilter) {
			if (!this.hasCustomData) this.setSchema();
			this.filter = {
				FieldId: this.reportFilter.ReportFieldId,
				Operator: this.reportFilter.Operator,
				Value: this.reportFilter.Value,
			};
			// this.filter.FieldId = this.reportFilter.ReportFieldId;
			// this.filter.Operator = this.reportFilter.Operator;
			// this.filter.Value = this.reportFilter.Value;
			this.show = true;
		} else this.filter = { FieldId: null, Operator: null, Value: null };
	},
	methods: {
		setSchema() {
			if (this.schemas && this.reportGridViewFields) {
				let field = this.reportFields.find(
					(x) => x.Id == this.reportFilter.ReportFieldId
				);
				if (field && field.GridViewFieldId) {
					let gvf = this.reportGridViewFields.find(
						(x) => x.Id == field.GridViewFieldId
					);
					if (gvf) {
						let schema = this.schemas.find(
							(x) => x.Id == gvf.EntityId
						);
						this.schema = schema.Id;
					}
				}
			}
		},

		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.$refs.form.validate()) return;
			if (!this.reportFilter) {
				this.add();
			} else {
				this.update();
			}
		},
		add() {
			let item = {
				ReportId: this.report.Id,
				ReportFieldId: this.filter.FieldId,
				Operator: this.filter.Operator,
				Value: this.filter.Value,
			};
			this.$store
				.dispatch(ReportDetailsActions.ADD_REPORT_FILTER, item)
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},

		update() {
			this.reportFilter.ReportFieldId = this.filter.FieldId;
			this.reportFilter.Operator = this.filter.Operator;
			this.reportFilter.Value = this.filter.Value;
			this.$store
				.dispatch(
					ReportDetailsActions.UPDATE_REPORT_FILTER,
					this.reportFilter
				)
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},
		filterChanged(item) {
			// this.filter = item
			this.filter = {
				FieldId: item.FieldId,
				Operator: item.Operator,
				Value: item.Value,
			};
		},
	},
};
</script>
